import { type Aperture, type ComponentEffect, toRender } from "refract-rxjs";
import { combineLatest } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";

import { type GetOrganicStatsQuery } from "../../lens-insights/api/queries";
import { type LensStatsItem, lensStatsModel } from "../models";

import { mapLensStats } from "./mapLensStats";

export interface LensOrganicStatsInput {
    data: GetOrganicStatsQuery | undefined;
    loading: boolean;
}

export interface LensOrganicStatsOutput {
    stats: LensStatsItem[];
}

export const getOrganicLensStatsEffect: Aperture<LensOrganicStatsInput, ComponentEffect<LensOrganicStatsOutput>> = ({
    observe,
}) => {
    const data$ = observe<GetOrganicStatsQuery | undefined>("data");
    const loading$ = observe<boolean>("loading");

    return combineLatest([data$, loading$]).pipe(
        filter((values): values is [GetOrganicStatsQuery, boolean] => {
            const [data, loading] = values;
            return !loading && data !== undefined && !!data.getMyLensesOrganicStats;
        }),
        map(([data]) => mapLensStats(data.getMyLensesOrganicStats.responseEntryList, lensStatsModel)),
        map((stats) => ({ stats: Object.values(stats) })),
        startWith({ stats: Object.values(lensStatsModel) }),
        map(({ stats }) => toRender<LensOrganicStatsOutput>({ stats })),
    );
};
